<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2 *ngIf="this.status === 'create'">Add New Agent</h2>
  <h2 *ngIf="this.status === 'edit'">Edit Agent - {{agentData.refNo}}</h2>
</div>

<div [ngClass]="!loading ? 'block' : 'hidden'">
  <section id="supplierDetails">
    <nz-card>
      <div>
        <form nz-form [formGroup]="agentForm">
          <div class="grid md:grid-cols-1 xl:grid-cols-2 gap-3">
            <div class="grid sm:grid-cols-2 gap-3">
              <nz-form-item class="grid grid-flow-row content-start"
                            [ngClass]="{'has-error': agentForm.get('email').invalid && agentForm.get('email').touched}">
                <nz-form-label nzFor="email" nzRequired>Agent Category</nz-form-label>
                <nz-form-control [nzErrorTip]="category">
                  <nz-select formControlName="category" nzAllowClear nzPlaceHolder="Select Category">
                    <nz-option nzValue="SR_TRANSFER" nzLabel="SR Transfer"></nz-option>
                    <nz-option nzValue="SR_RENT" nzLabel="SR Rent"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #category>
                  <span *ngIf="agentForm.get('category').hasError('required')">Please select Category.</span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>

          <div class="grid md:grid-cols-1 xl:grid-cols-2 gap-3">
            <div class="grid sm:grid-cols-1 gap-3">
              <nz-form-item class="grid grid-flow-row content-start"
                            [ngClass]="{'has-error': agentForm.get('email').invalid && agentForm.get('email').touched}">
                <nz-form-label nzFor="name" nzRequired>Agent Name</nz-form-label>
                <nz-form-control [nzErrorTip]="nameSupplier">
                  <input nz-input type="text" [maxLength]="70"
                         formControlName="name" placeHolder="Enter Full Name"/>
                </nz-form-control>
                <ng-template #nameSupplier>
                <span
                  *ngIf="agentForm.get('name').hasError('required')">Please Enter Agent Name</span>
                  <span *ngIf="agentForm.get('name').hasError('maxlength')">
                  Maximum length is 70 characters</span>
                  <span *ngIf="agentForm.get('name').hasError('pattern')">
                    Agent name error</span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>

          <div class="grid md:grid-cols-1 xl:grid-cols-2 gap-3">
            <div class="grid sm:grid-cols-2 gap-3">
              <nz-form-item class="grid grid-flow-row content-start"
                            [ngClass]="{'has-error': agentForm.get('contactNo').invalid && agentForm.get('contactNo').touched}">
                <nz-form-label nzFor="mobileNo" nzRequired>Agent Contact Number</nz-form-label>
                <nz-form-control [nzErrorTip]="mobileNo">
                  <input nz-input type="text" formControlName="contactNo" [maxLength]="15"
                         placeHolder="Enter Contact Number"/>
                </nz-form-control>
                <ng-template #mobileNo>
                  <span *ngIf="agentForm.get('contactNo').hasError('required')">Please Enter Contact Number</span>
                  <span *ngIf="agentForm.get('contactNo').hasError('maxlength')"> Maximum length is 15 characters</span>
                  <span *ngIf="agentForm.get('contactNo').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                            [ngClass]="{'has-error': agentForm.get('email').invalid && agentForm.get('email').touched}">
                <nz-form-label nzFor="email" nzRequired>Agent Email</nz-form-label>
                <nz-form-control [nzErrorTip]="email">
                  <input nz-input type="text" formControlName="email" placeHolder="Enter Agent Email"/>
                </nz-form-control>
                <ng-template #email>
                  <span *ngIf="agentForm.get('email').hasError('required')">Please Enter Email</span>
                  <span *ngIf="agentForm.get('email').hasError('maxlength')">Maximum length is 100 characters</span>
                  <span
                    *ngIf="formErrors?.email?.email">Invalid email address, please review your input.</span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>
        </form>

        <div class="grid md:grid-cols-1 xl:grid-cols-2 gap-3">
          <div class="grid sm:grid-cols-1 gap-3">
            <div>
              <p class="pb-[8px] font-normal">Attachments (Contracts)</p>

              <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                <div>
                  <nz-upload
                    [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"
                    (cancel)="attachmentUploading = false">
                    <button nz-button>
                      <span nz-icon nzType="upload"></span>
                      Click to Upload
                    </button>
                  </nz-upload>
                </div>
                <div>
                  <p *ngIf="attachmentUploading" class="text-primary my-2">Uploading...</p>
                </div>
                <div class="mt-2 overflow-auto">
                  <div *ngFor="let file of attachments; let i = index"
                       class="flex justify-between items-center mx-3 gap-5">
                    <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                    <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                          [nzTwotoneColor]="'#ff0000'"
                          class="cursor-pointer" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this attachment"
                          (nzOnConfirm)="confirmRemoveAttachment(i)"
                    ></span>
                  </div>
                </div>
              </div>

              <!--              <nz-upload [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"-->
              <!--                         class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
              <!--                <button nz-button>-->
              <!--                  <span nz-icon nzType="upload"></span>-->
              <!--                  Click to Upload-->
              <!--                </button>-->
              <!--              </nz-upload>-->
              <!--              <div *ngFor="let file of paymentFiles;let i = index">-->
              <!--                <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
              <!--                                                                                    nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
              <!--                                                                                    nzPopconfirmPlacement="bottom"-->
              <!--                                                                                    (nzOnConfirm)="confirmRemoveAttachment(i)"-->
              <!--                                                                                    (nzOnCancel)="cancel()"nzTheme="outline"></span></a>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="buttons" class="mt-6">
    <nz-card>
      <div class="flex justify-end sm:justify-end">
        <a
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="confirm()"
          (nzOnCancel)="cancel()"
        >
          <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
        </a>
        <button nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to save the record?"
                nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="onSubmit()"
                (nzOnCancel)="cancel()" nz-button nzType="primary"
                [disabled]="agentForm.invalid">Update Agent
        </button>
        <!--      <button nz-popconfirm-->
        <!--              nzPopconfirmTitle="Are you sure you want to save the record?"-->
        <!--              nzPopconfirmPlacement="bottom"-->
        <!--              (nzOnConfirm)="onUpdate()"-->
        <!--              (nzOnCancel)="cancel()"-->
        <!--              nz-button nzType="primary" *ngIf="this.status === 'edit'"-->
        <!--              [disabled]="agentForm.invalid">Update Agent-->
        <!--      </button>-->
      </div>
    </nz-card>
  </section>
</div>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>
